// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 97 ? "npm.regenerator-runtime" : chunkId) + "." + {"97":"8e48271b","414":"bc670e3c"}[chunkId] + ".chunk.js";
};